import { render, staticRenderFns } from "./Convenios.vue?vue&type=template&id=163480c8&scoped=true&"
import script from "./Convenios.vue?vue&type=script&lang=js&"
export * from "./Convenios.vue?vue&type=script&lang=js&"
import style0 from "./Convenios.vue?vue&type=style&index=0&id=163480c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163480c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VDivider,VFlex,VLayout})
